import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import { ROUTES, WA_MESSAGES, WHATSAPP_DISPLAY, openTelegram, openWhatsApp } from '../../../config/site';

const FLOATERS = [
  { id: 1, type: 'chip', x: '2.5%', y: '12%', size: 70, delay: '0s', tone: 'gold' },
  { id: 2, type: 'card', x: '95%', y: '10%', size: 66, delay: '1.2s', tone: 'red' },
  { id: 3, type: 'dice', x: '95.5%', y: '74%', size: 58, delay: '2.1s', tone: 'white' },
  { id: 4, type: 'chip', x: '1.5%', y: '82%', size: 54, delay: '0.7s', tone: 'green' },
  { id: 5, type: 'card', x: '3%', y: '48%', size: 52, delay: '2.8s', tone: 'gold' },
];

const TICKER = [
  { name: 'Rahul K.', city: 'Jaipur', amount: '₹1,24,500', game: 'Teen Patti Gold' },
  { name: 'Priya S.', city: 'Delhi NCR', amount: '₹78,000', game: 'Andar Bahar Royal' },
  { name: 'Imran A.', city: 'Hyderabad', amount: '₹2,10,000', game: 'Dragon Tiger' },
  { name: 'Meera J.', city: 'Pune', amount: '₹46,800', game: 'Lightning Roulette' },
];

const HeroSection = () => {
  const [tickIndex, setTickIndex] = useState(0);
  const [tilt, setTilt] = useState({ x: -6, y: 10 });
  const cardRef = useRef(null);

  useEffect(() => {
    const t = setInterval(() => setTickIndex((i) => (i + 1) % TICKER.length), 3200);
    return () => clearInterval(t);
  }, []);

  const handleTilt = (e) => {
    const rect = cardRef.current?.getBoundingClientRect();
    if (!rect) return;
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    setTilt({ x: -py * 18, y: px * 22 });
  };

  const winner = TICKER[tickIndex];

  return (
    <section className="relative isolate overflow-hidden pb-12 pt-8 lg:pb-16 lg:pt-12">
      {/* Ambience */}
      <span className="aurora left-[-10%] top-[-6%] h-[26rem] w-[26rem] bg-royal-gold/40" aria-hidden="true" />
      <span className="aurora right-[-8%] top-[8%] h-[30rem] w-[30rem] bg-royal-violet/45" aria-hidden="true" />
      <span className="aurora bottom-[-14%] left-[35%] h-[26rem] w-[26rem] bg-wa-green/25" aria-hidden="true" />
      <div className="absolute inset-0 grid-lines" aria-hidden="true" />

      {/* Floating 3D props */}
      {FLOATERS.map((f) => (
        <div
          key={f.id}
          className="pointer-events-none absolute hidden animate-float lg:block"
          style={{ left: f.x, top: f.y, animationDelay: f.delay }}
          aria-hidden="true"
        >
          {f.type === 'chip' && (
            <div
              className="coin-3d flex items-center justify-center rounded-full font-display font-bold text-[#150F02]"
              style={{
                width: f.size,
                height: f.size,
                background:
                  f.tone === 'green'
                    ? 'radial-gradient(circle at 32% 26%, #9CFFC9, #25D366 55%, #0A6634)'
                    : 'radial-gradient(circle at 32% 26%, #FFF6D0, #F0C24B 52%, #7A5406)',
                boxShadow:
                  '0 1px 0 rgba(255,255,255,0.7) inset, 0 -6px 12px rgba(0,0,0,0.4) inset, 0 24px 40px -18px rgba(0,0,0,0.95)',
                border: '3px dashed rgba(255,255,255,0.45)',
                fontSize: f.size * 0.34,
              }}
            >
              ₹
            </div>
          )}
          {f.type === 'card' && (
            <div
              className="flex items-center justify-center rounded-xl border border-white/70 bg-gradient-to-br from-white to-[#E6E2D6] shadow-[0_26px_44px_-20px_rgba(0,0,0,0.95)]"
              style={{ width: f.size * 0.72, height: f.size, transform: 'rotate(-12deg)' }}
            >
              <Icon name="Spade" size={f.size * 0.4} color={f.tone === 'red' ? '#FF3D71' : '#0B0B14'} />
            </div>
          )}
          {f.type === 'dice' && (
            <div
              className="grid grid-cols-2 place-items-center gap-1.5 rounded-2xl border border-white/60 bg-gradient-to-br from-white to-[#DCD8CC] p-3 shadow-[0_26px_44px_-20px_rgba(0,0,0,0.95)]"
              style={{ width: f.size, height: f.size, transform: 'rotate(14deg)' }}
            >
              {[0, 1, 2, 3].map((d) => (
                <span key={d} className="h-2 w-2 rounded-full bg-[#0B0B14]" />
              ))}
            </div>
          )}
        </div>
      ))}

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-[1.05fr_0.95fr]">
          {/* ------------------------------ Copy ------------------------------ */}
          <div className="animate-rise text-center lg:text-left">
            <span className="badge-pill mx-auto lg:mx-0">
              <Icon name="BadgeCheck" size={13} /> Official Portal · nitinonlinehub.online
            </span>

            <div className="mt-4 flex flex-wrap items-center justify-center gap-3 lg:justify-start">
              <div className="inline-flex items-center justify-center gap-2 rounded-full border border-royal-gold/45 bg-royal-gold/16 px-5 py-3 text-base font-bold text-royal-gold shadow-[0_2px_0_rgba(255,255,255,0.16)_inset,0_10px_30px_rgba(240,194,75,0.16)] lg:justify-start">
                <Icon name="ShieldCheck" size={17} color="#F0C24B" />
                A Govt. of India Undertaking · Govt verified
              </div>

              <div className="inline-flex items-center justify-center rounded-full border border-white/15 bg-white/[0.08] px-5 py-3 text-base font-bold uppercase tracking-[0.24em] text-white/90 backdrop-blur-royal shadow-[0_1px_0_rgba(255,255,255,0.14)_inset] lg:justify-start">
                NITINN ONLINE Book - Honours Your Trust
              </div>
            </div>

            <h1 className="mt-6 font-heading text-mega font-bold text-white text-shadow-deep [text-wrap:balance]">
              <span className="gold-text">Nitin Online Book</span>
              <br />
              <span className="text-white/95">&amp; Nitin Online Exchange</span>
              <br />
              <span className="relative inline-block">
                <span className="gold-text">Play Royal. Win Fast.</span>
                <span className="absolute -bottom-2 left-0 h-1 w-full rounded-full bg-gradient-to-r from-royal-gold via-gold-light to-transparent" />
              </span>
            </h1>

            <p className="mx-auto mt-8 max-w-xl text-body-lg text-white/65 lg:mx-0">
              This is the verified home of <strong className="text-white/90">Nitin Online Book</strong> and{' '}
              <strong className="text-white/90">Nitin Online Book</strong> — the trusted place for{' '}
              <em className="not-italic text-royal-gold">Nitin online book login</em>,{' '}
              <em className="not-italic text-royal-gold">sign up</em> and{' '}
              <em className="not-italic text-royal-gold">app download</em>. Secure gaming in India, genuine 24/7
              WhatsApp support, and withdrawals that clear in about five minutes.
            </p>

            {/* Trust chips */}
            <div className="mt-8 flex flex-wrap justify-center gap-3 lg:justify-start">
              {[
                { icon: 'Users', label: '10,000+ verified players', color: '#F0C24B' },
                { icon: 'Zap', label: 'Instant 5-min payouts', color: '#25D366' },
                { icon: 'ShieldCheck', label: '100% secure & fair', color: '#5B8CFF' },
              ].map((chip) => (
                <span
                  key={chip.label}
                  className="flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.06] px-4 py-2 text-sm text-white/80 backdrop-blur-royal shadow-[0_1px_0_rgba(255,255,255,0.14)_inset]"
                >
                  <Icon name={chip.icon} size={16} color={chip.color} />
                  {chip.label}
                </span>
              ))}
            </div>

            {/* CTAs */}
            <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row lg:justify-start">
              <button onClick={() => openWhatsApp(WA_MESSAGES.newId)} className="btn-3d btn-3d-wa shine-hover w-full sm:w-auto">
                <FaWhatsapp size={21} />
                Get your Gaming ID
              </button>
              <button onClick={openTelegram} className="btn-3d btn-3d-ghost w-full sm:w-auto">
                <FaTelegramPlane size={19} />
                Join Telegram VIP
              </button>
            </div>

            <p className="mt-4 text-sm text-white/45">
              Direct line · <span className="font-semibold text-white/75">{WHATSAPP_DISPLAY}</span> · replies in under 2 minutes
            </p>

            {/* Stats */}
            <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {[
                { value: '₹50L+', label: 'Paid daily' },
                { value: '24/7', label: 'WhatsApp desk' },
                { value: '50+', label: 'Premium games' },
                { value: '5 Min', label: 'Withdrawals' },
              ].map((s, i) => (
                <div key={s.label} className="stat-3d animate-rise" style={{ animationDelay: `${150 + i * 90}ms` }}>
                  <div className="font-display text-2xl font-bold gold-text">{s.value}</div>
                  <div className="mt-1 text-xs uppercase tracking-[0.14em] text-white/45">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ------------------------- 3D membership card ------------------------- */}
          <div className="perspective relative mx-auto w-full max-w-md">
            <div
              ref={cardRef}
              onMouseMove={handleTilt}
              onMouseLeave={() => setTilt({ x: -6, y: 10 })}
              className="preserve-3d relative transition-transform duration-300 ease-royal"
              style={{ transform: `rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)` }}
            >
              {/* Stacked depth plates */}
              <div className="absolute inset-x-6 -bottom-6 top-10 rounded-[30px] bg-royal-gold/20 blur-2xl" aria-hidden="true" />
              <div
                className="absolute inset-0 rounded-[28px] border border-white/10 bg-white/5"
                style={{ transform: 'translateZ(-40px) scale(0.94)' }}
                aria-hidden="true"
              />
              <div
                className="absolute inset-0 rounded-[28px] border border-white/10 bg-white/[0.07]"
                style={{ transform: 'translateZ(-20px) scale(0.97)' }}
                aria-hidden="true"
              />

              {/* The card */}
              <div className="panel-gold shine relative overflow-hidden rounded-[28px] p-7">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="text-[0.62rem] uppercase tracking-[0.28em] text-white/45">Membership</p>
                    <p className="mt-1 font-heading text-2xl font-bold gold-text">Royal VIP Pass</p>
                  </div>
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl border border-royal-gold/40 bg-black/40">
                    <Icon name="Crown" size={24} color="#F0C24B" />
                  </span>
                </div>

                <div
                  className="mt-7 flex items-center gap-3"
                  style={{ transform: 'translateZ(30px)' }}
                >
                  <span className="h-9 w-12 rounded-md bg-gradient-to-br from-[#FFF0B8] via-[#F0C24B] to-[#7A5406] shadow-[0_1px_0_rgba(255,255,255,0.6)_inset]" />
                  <span className="font-display text-lg tracking-[0.18em] text-white/85">•••• 7309</span>
                </div>

                <div className="mt-6 grid grid-cols-2 gap-4 text-sm" style={{ transform: 'translateZ(20px)' }}>
                  <div>
                    <p className="text-[0.62rem] uppercase tracking-[0.2em] text-white/40">Player</p>
                    <p className="mt-1 font-display font-semibold text-white">Your Name Here</p>
                  </div>
                  <div>
                    <p className="text-[0.62rem] uppercase tracking-[0.2em] text-white/40">Status</p>
                    <p className="mt-1 font-display font-semibold text-wa-green">Instant approval</p>
                  </div>
                </div>

                <div className="divider-glow my-6" />

                {/* Live payout ticker */}
                <div className="rounded-2xl border border-white/10 bg-black/40 p-4" style={{ transform: 'translateZ(24px)' }}>
                  <div className="mb-3 flex items-center justify-between">
                    <span className="flex items-center gap-2 text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-wa-green">
                      <span className="relative flex h-2 w-2">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-wa-green opacity-75" />
                        <span className="relative inline-flex h-2 w-2 rounded-full bg-wa-green" />
                      </span>
                      Live payout
                    </span>
                    <span className="text-[0.62rem] text-white/35">just now</span>
                  </div>

                  <div key={winner.name} className="animate-rise flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#FFF0B8] to-[#C4901A] font-display text-sm font-bold text-[#0B0B14]">
                        {winner.name.charAt(0)}
                      </span>
                      <div>
                        <p className="text-sm font-semibold text-white">{winner.name}</p>
                        <p className="text-[0.68rem] text-white/45">{winner.city} · {winner.game}</p>
                      </div>
                    </div>
                    <p className="font-display text-lg font-bold text-wa-green">+{winner.amount}</p>
                  </div>
                </div>

                <Link
                  to={ROUTES.games}
                  className="mt-6 flex items-center justify-center gap-2 rounded-full border border-white/12 bg-white/[0.06] py-3 text-sm font-medium text-white/80 transition hover:border-royal-gold/60 hover:text-white"
                  style={{ transform: 'translateZ(18px)' }}
                >
                  Explore the gaming palace
                  <Icon name="ArrowRight" size={15} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="mt-10 flex justify-center">
        <span className="flex h-11 w-7 items-start justify-center rounded-full border border-white/20 p-1.5">
          <span className="h-2 w-1 animate-bounce rounded-full bg-royal-gold" />
        </span>
      </div>
    </section>
  );
};

export default HeroSection;
